var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SwipeContainer", {
    attrs: {
      title: "Press the swap button",
      subtext: "And get other recommendations",
      type: "swap"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-030d22c4", { render: render, staticRenderFns: staticRenderFns })
  }
}